<style scoped>
  .row {
    cursor: pointer;
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
  }
  .all-rank-list {
    cursor: pointer;
  }
  .rank-list:hover {
    background-color: #F3F4F5;
  }
  /* .rank-list:hover .prize-img {
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
    transform: scale(1.2,1.2);
    -webkit-transform: scale(1.3,1.3);
  } */
  .left-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .5rem;
    flex-basis: 3.125rem;
  }
</style>

<template>
  <div class="article-list-by-tag m-container-max" style="background-color: #fff;">
    <div class="rank-title-wrapper" style="height: 2.875rem;line-height: 2.875rem;border-bottom: 1px solid rgba(222, 223, 224, 0.5);">
      <p style="text-align: center;font-size: 1.0625rem;">{{keyword}}</p>
    </div>
    <div @touchmove="loadArticleList()" @mousewheel="loadArticleList()">
      <div class="rank-list" style="display: flex;flex-direction: row;border-bottom: 1px solid rgba(222, 223, 224, 0.5);" v-for="item in articleList" :key="item.id" @click="getArticleDetail(item.submsgs[0])">
        <div class="left-box">
          <img class="prize-img" :src="item.submsgs[0].coverImg" alt="" style="width: 6.94rem;height: 4.56rem;border-radius: .1875rem;">
        </div>
        <div class="rank-num right-box" style="flex: 1;display: flex;padding: .75rem;flex-direction: column;justify-content: space-between;">
          <div>{{item.submsgs[0].title}}</div>
          <div style="display: flex;flex-direction: column;">
            <div>
              <span style="font-size: .875rem;color: rgb(130, 140, 155);margin-right: .25rem;">{{item.submsgs[0].author }}</span>
              <span style="font-size: .875rem;color: rgb(130, 140, 155);">{{item.submsgs[0].createTime | showWeekday }}</span>
            </div>
            <div>
              <img src="../assets/images/readNum.png" alt="" style="width: 1rem;height: .6875rem;margin-right: .25rem;font-size: 1.125rem;font-weight: 500;">
              <span style="font-size: .875rem;margin-right: .25rem;color: rgb(130, 140, 155);">{{item.submsgs[0].readednum || 0}}</span>
              <img src="../assets/images/comment.png" alt="" style="width: 1rem;height: .6875rem;margin-right: .25rem;font-size: 1.125rem;font-weight: 500;">
              <span style="font-size: .875rem;margin-right: .25rem;color: rgb(130, 140, 155);">{{item.submsgs[0].commentnum || 0}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;background-color: rgba(0,0,0,.5);z-index: 10002;" v-if="errorStatus"></div>
  </div>
</template>

<script>
import { tagMixin } from '../mixins/tag'
export default {
  name: 'articleListByTag',
  mixins: [tagMixin]
}
</script>
